import { render, staticRenderFns } from "./ProgressLabel.vue?vue&type=template&id=c2b5ef32&scoped=true"
import script from "@/views/Users/Student/Progress/ProgressLabel.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Progress/ProgressLabel.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/Progress/progress-label.scss?vue&type=style&index=0&id=c2b5ef32&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b5ef32",
  null
  
)

export default component.exports